module.exports = __webpack_public_path__ + "img/m-icon-s-air.ed3de691.png";